/**
 * 檔案用途區塊
 * @module common.enum
 * @purpose 集中定義 HTTP 請求標頭鍵名與語系代碼列舉，供跨模組請求與國際化參數使用。
 */

/**
 * 宣告內容用途說明與單號關聯
 * @description HTTP 請求時使用的標頭欄位鍵名。
 * @purpose 統一前後端溝通所需 header key，避免硬編字串造成拼寫不一致。
 */
export enum HttpClientHeaderItem {
  Authorization = 'authorization',
  Language = 'accept-language',
  Timezone = 'time-zone',
  Currency = 'currency',
  IM_Vendor = 'pvd',
  DeviceMode = 'deviceMode',
  PhoneBrand = 'phoneBrand',
  Browser = 'browser',
  Screen = 'screen',
  Cks = 'cks',
  X_Uuid = 'x-uuid',
  Version = 'version',
  isPC = 'pc',
  Checksum = 'x-checksum',
}

/**
 * 宣告內容用途說明與單號關聯
 * @description 以連字號格式呈現的語系列舉值（例如 en-us），主要用於 API header。
 * @purpose 供國際化與請求層共用語系代碼，確保語系傳遞格式一致。
 */
export enum LocaleDash {
  en_US = 'en-us',
  id_ID = 'id-id',
  ms_MY = 'ms-my',
  vi_VN = 'vi-vn',
  zh_CN = 'zh-cn',
  zh_HK = 'zh-hk',
  ja_JP = 'ja-jp',
  ko_KR = 'ko-kr',
  th_TH = 'th-th',
  hi_IN = 'hi-in',
  pt_PT = 'pt-pt',
  es_ES = 'es-es',
  en_IN = 'en-in',
  en_PH = 'en-ph',
  tl_PH = 'tl-ph',
  tr_TR = 'tr-tr',
  bn_BD = 'bn-bd',
  en_NG = 'en-ng',
}

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:21:50.230Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note 已僅調整註解並保留程式邏輯不變：新增檔案頂部「檔案用途區塊」、為兩個 enum 新增「宣告內容用途說明與單號關聯」註解、移除成員層級與無單號來源的 @external、補上底部「llm 分析紀錄區」。
 */
